import React from "react";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PreviewCard,
  Icon,
  Button,
} from "../Component";
import { Spinner } from "reactstrap";
import { useIntelligentReportGeneration, IntelligentReportSynthesisContent } from "./intelligentReportShared";

/**
 * @param {() => object} getPayload — doit retourner { kind: 'monthly'|'site'|'custom', ...champs alignés sur l'API }
 * @param {string} [buttonLabel]
 * @param {'default'|'compact'} [variant] — compact : libellés courts, carte discrète (ex. rapports perso)
 * @param {string} [title]
 * @param {string|null} [subtitle] — null ou chaîne vide : pas de texte sous le titre
 * @param {boolean} [disabled] — désactive le bouton (ex. prérequis non remplis)
 * @param {string} [disabledHint] — court message sous le bouton si disabled
 * @param {{ subtitle?: string, filename?: string }} [pdfMeta] — entête / nom de fichier pour l'export PDF de la synthèse
 */
const IntelligentReportBlock = ({
  getPayload,
  buttonLabel = "Générer le rapport intelligent",
  variant = "default",
  title,
  subtitle,
  disabled = false,
  disabledHint,
  pdfMeta,
}) => {
  const isCompact = variant === "compact";
  const cardClass = isCompact ? "card-bordered" : "card-bordered border-primary";
  const mainTitle = title ?? (isCompact ? "Synthèse IA" : "Rapport intelligent (Groq)");
  const showSubtitle =
    subtitle !== null && subtitle !== undefined && String(subtitle).trim() !== "";

  const { loading, intelligent, run } = useIntelligentReportGeneration(getPayload, {
    disabled,
    isCompact,
  });

  return (
    <Block>
      <PreviewCard className={cardClass}>
        <div className="card-inner">
          <BlockHead size="sm" className="mb-3">
            <BlockHeadContent>
              <BlockTitle tag="h6" className={isCompact ? "" : "d-flex align-items-center gap-2"}>
                {!isCompact && <Icon name="cpu" />}
                {mainTitle}
              </BlockTitle>
              {showSubtitle && (
                <BlockDes className="text-soft">
                  <p className="mb-0 small">{subtitle}</p>
                </BlockDes>
              )}
              {!isCompact && !showSubtitle && (
                <BlockDes className="text-soft">
                  <p className="mb-0 small">
                    Synthèse rédigée à partir des <strong>mêmes données</strong> que le rapport ci-dessous. À valider
                    par un responsable HSE.
                  </p>
                </BlockDes>
              )}
            </BlockHeadContent>
          </BlockHead>

          <Button
            color="primary"
            outline={!isCompact}
            className="mb-3"
            onClick={run}
            disabled={loading || disabled}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Génération en cours…
              </>
            ) : (
              <>
                <Icon name="file-text" className="me-1" />
                {buttonLabel}
              </>
            )}
          </Button>
          {disabled && disabledHint && (
            <p className="text-soft small mb-3">{disabledHint}</p>
          )}

          <IntelligentReportSynthesisContent intelligent={intelligent} pdfMeta={pdfMeta} />
        </div>
      </PreviewCard>
    </Block>
  );
};

export default IntelligentReportBlock;
